import { render } from "./beautyVideoInfo.vue?vue&type=template&id=41a0a974&scoped=true"
import script from "./beautyVideoInfo.vue?vue&type=script&lang=js"
export * from "./beautyVideoInfo.vue?vue&type=script&lang=js"

import "./beautyVideoInfo.vue?vue&type=style&index=0&id=41a0a974&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a0a974"]])

export default __exports__